// src/components/bar/ProductDetail.js
import React from 'react';
import styles from './ProductDetail.module.css';

const ProductDetail = ({ product, productsFromDatabase = true, onClose, onOrder, isOrdering = false, hasActiveOrder = false, paymentStatus = 'unpaid', hasFullName = true, onShowPayment, onShowProfile }) => {
  // 支払いポップアップを表示
  const goToPayment = () => {
    onClose();
    if (onShowPayment) {
      onShowPayment();
    }
  };

  // 注文ボタンの表示を決定
  const renderOrderButton = () => {
    if (isOrdering) {
      return (
        <div className={styles.orderingMessage}>
          こちらの商品は現在製作中です
        </div>
      );
    }
    
    if (hasActiveOrder) {
      return (
        <div className={styles.orderingMessage}>
          他の注文が完了するまで新たに注文できません
        </div>
      );
    }

    if (paymentStatus === 'pending') {
      return (
        <div className={styles.pendingMessage}>
          <div className={styles.pendingAlert}>
            支払い確認待ちのため注文できません
          </div>
          <button
            onClick={goToPayment}
            className={styles.pendingButton}
          >
            支払い状況を確認する
          </button>
        </div>
      );
    }

    if (paymentStatus !== 'completed') {
      return (
        <div className={styles.unpaidMessage}>
          <div className={styles.unpaidAlert}>
            注文するには先に支払いが必要です
          </div>
          <button
            onClick={goToPayment}
            className={styles.unpaidButton}
          >
            お支払いページへ
          </button>
        </div>
      );
    }

    // 本名（姓・名）未登録の場合は注文ボタンを表示せず、プロフィール設定を促す
    if (!hasFullName) {
      return (
        <div className={styles.unpaidMessage}>
          <div className={styles.unpaidAlert}>
            注文するにはプロフィールで本名（姓・名）の登録が必要です
          </div>
          {onShowProfile && (
            <button
              onClick={onShowProfile}
              className={styles.unpaidButton}
            >
              プロフィールを設定
            </button>
          )}
        </div>
      );
    }

    return (
      <button
        onClick={onOrder}
        className={styles.orderButton}
      >
        注文する
      </button>
    );
  };

  return (
    <div className={styles.modal}>
      <div className={styles.modalContainer}>
        {/* 閉じるボタン - 小さく右上に配置 */}
        <button 
          onClick={onClose}
          className={styles.closeButton}
          aria-label="閉じる"
        >
          ✕
        </button>
        
        {/* 製作中バッジ */}
        {isOrdering && (
          <div className={styles.inProgressBadge}>
            製作中
          </div>
        )}
        
        {/* 画像を1:1の比率で表示、中央揃え */}
        <div className={styles.imageContainer}>
          <img 
            src={product.image || "/api/placeholder/400/400"} 
            alt={product.name}
            className={styles.productImage}
          />
        </div>
        
        <h2 className={styles.productName}>{product.name}</h2>
        <p className={styles.productDescription}>{product.description}</p>
        <p className={styles.productPrice}>
          ¥{product.price}
          {!productsFromDatabase && <span className={styles.localInfoBadge}> ローカル情報表示</span>}
        </p>
        
        {renderOrderButton()}
      </div>
    </div>
  );
};

export default ProductDetail;